import type { Document, Evaluation, Roadmap, Task } from '@/shared/api/queries'

export function evaluationsOf(roadmap: Roadmap | undefined): Evaluation[] {
  return roadmap ? [...roadmap.now, ...roadmap.later, ...roadmap.done] : []
}

export function requirementOf(task: Task, evaluations: Evaluation[]): Evaluation | undefined {
  if (task.origin !== 'requirement' || !task.origin_key) {
    return undefined
  }

  return evaluations.find((evaluation) => evaluation.key === task.origin_key)
}

export function areaOf(task: Task, evaluations: Evaluation[]): string | undefined {
  return requirementOf(task, evaluations)?.category
}

export function tasksOfArea(tasks: Task[], evaluations: Evaluation[], area: string): Task[] {
  return tasks.filter((task) => areaOf(task, evaluations) === area)
}

export interface RequiredDocument {
  type: string
  document: Document | undefined
}

export function requiredDocumentsOf(
  requirement: Evaluation | undefined,
  documents: Document[],
): RequiredDocument[] {
  return (requirement?.required_documents ?? []).map((type) => ({
    type,
    document: documents.find((candidate) => candidate.type === type),
  }))
}

export function tasksNeedingDocument(
  type: string,
  tasks: Task[],
  evaluations: Evaluation[],
): Task[] {
  return tasks.filter((task) =>
    requirementOf(task, evaluations)?.required_documents?.includes(type),
  )
}
